export default __webpack_public_path__ + "static/media/vol1_4.d3c097ac.png";